<div class="inner-content">
  <ion-card class="custom-card">
    <div class="gradient-bg">
      <ion-card-header>
        <ion-card-title>
          <span class="descriptions">No device</span>
          <i *ngIf="!position.lat && !position.lon" class="no-geo">Position in (0,0)</i>

          <ng-container *ngIf="position.labels">
            <ion-chip *ngFor="let label of position.labels">
              <ion-icon name="pricetag-outline" color="primary"></ion-icon>
              <ion-label color="primary">{{label.label}}</ion-label>
            </ion-chip>
          </ng-container>

          <ion-spinner *ngIf="loading"></ion-spinner>

        </ion-card-title>
      </ion-card-header>

      <ion-card-content>
        <ion-text color="dark">
          Zone: <span class="descriptions">{{zone?.name || 'unknown'}}</span>
        </ion-text>
        <br/>
        <ion-text color="dark" *ngIf="position.custom_id">
          Custom ID: <span class="descriptions">{{position.custom_id}}</span>
        </ion-text>
        <ion-text color="dark" *ngIf="!position.custom_id">
          No Custom ID
        </ion-text>
        <br/>
        <ion-text color="dark" *ngIf="position.network_id">
          Network ID: <span class="descriptions">{{position.network_id}}</span>
        </ion-text>
        <ion-text color="dark" *ngIf="!position.network_id">
          Network ID is missed
        </ion-text>

        <ion-grid class="ion-margin-top ion-no-padding">
          <ion-row class="ion-no-margin ion-no-padding ion-justify-content-between ion-align-items-center">
            <ion-col size="auto" class="ion-no-margin ion-no-padding">
              <ion-button color="success" (click)="bind()" [disabled]="(access() | async) === false || loading">
                <ion-icon slot="start" name="lock-closed"></ion-icon>
                Bind
              </ion-button>
            </ion-col>
            <ion-col size="auto" class="ion-no-margin ion-no-padding">
              <ion-button (click)="edit()" [disabled]="(access() | async) === false || loading">
                <ion-icon slot="start" name="pencil"></ion-icon>
                Edit
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card-content>
    </div>
  </ion-card>
</div>
